@if (vm$ | async; as vm) {
  <form
    [formGroup]="form"
    [nwxExposeFormErrors]="form"
    formName="sinkhole-details"
    >
    <div [class.card-padding]="!vm.insideModal">
      <h2>Sinkhole questions</h2>
      <div class="bolt-container-fluid inner-card">
        <div class="bolt-row question-row">
          <div class="bolt-col-12 bolt-col-sm-9 question-col">
            Have you been told or do you have any knowledge that this property has ever experienced damage or loss resulting from sinkhole activity or collapse, or been the subject of any ground movement investigation?
          </div>
          <div class="bolt-col-12 bolt-col-sm-3">
            <bolt-radio-group
              ngDefaultControl
              formControlName="hasPropertyExperiencedSinkholeDamage"
              [attr.horizontal]="horizontalRadio || null"
              id="shf-hasPropertyExperiencedSinkholeDamage"
              required
              [error]="errorMessage['hasPropertyExperiencedSinkholeDamage']"
              >
              <bolt-radio value="true">Yes</bolt-radio>
              <bolt-radio value="false">No</bolt-radio>
            </bolt-radio-group>
          </div>
        </div>
        <div class="bolt-row">
          <div class="bolt-col-12">
            <hr />
          </div>
        </div>
        <div class="bolt-row question-row">
          <div class="bolt-col-12 bolt-col-sm-9 question-col">
            Have you been told or do you have any knowledge that the property does, or has it ever had, sinkhole activity or any other movement, whether confirmed or not, regardless if it was tested or not?
          </div>
          <div class="bolt-col-12 bolt-col-sm-3">
            <bolt-radio-group
              ngDefaultControl
              formControlName="hasPropertyHadSinkholeActivity"
              [attr.horizontal]="horizontalRadio || null"
              id="shf-hasPropertyHadSinkholeActivity"
              required
              [error]="errorMessage['hasPropertyHadSinkholeActivity']"
              >
              <bolt-radio value="true">Yes</bolt-radio>
              <bolt-radio value="false">No</bolt-radio>
            </bolt-radio-group>
          </div>
        </div>
        <div class="bolt-row">
          <div class="bolt-col-12">
            <hr />
          </div>
        </div>
        <div class="bolt-row question-row">
          <div class="bolt-col-12 bolt-col-sm-9 question-col">
            Has the applicant ever reported any potential sinkhole, settlement or cracking damage or loss to this property?
          </div>
          <div class="bolt-col-12 bolt-col-sm-3">
            <bolt-radio-group
              ngDefaultControl
              formControlName="hasApplicantReportedSinkholeDamage"
              [attr.horizontal]="horizontalRadio || null"
              id="shf-hasApplicantReportedSinkholeDamage"
              required
              [error]="errorMessage['hasApplicantReportedSinkholeDamage']"
              >
              <bolt-radio value="true">Yes</bolt-radio>
              <bolt-radio value="false">No</bolt-radio>
            </bolt-radio-group>
          </div>
        </div>
        <div class="bolt-row">
          <div class="bolt-col-12">
            <hr />
          </div>
        </div>
        <div class="bolt-row question-row">
          <div class="bolt-col-12 bolt-col-sm-9 question-col">
            Does the applicant have any knowledge that any sinkhole, settlement or cracking exists on this property?
          </div>
          <div class="bolt-col-12 bolt-col-sm-3">
            <bolt-radio-group
              ngDefaultControl
              formControlName="doesApplicantKnowOfSinkholeDamage"
              [attr.horizontal]="horizontalRadio || null"
              id="shf-doesApplicantKnowOfSinkholeDamage"
              required
              [error]="errorMessage['doesApplicantKnowOfSinkholeDamage']"
              >
              <bolt-radio value="true">Yes</bolt-radio>
              <bolt-radio value="false">No</bolt-radio>
            </bolt-radio-group>
          </div>
        </div>
        <div class="bolt-row">
          <div class="bolt-col-12">
            <hr />
          </div>
        </div>
        <div class="bolt-row question-row">
          <div class="bolt-col-12 bolt-col-sm-9 question-col">
            Does the applicant have any knowledge that any prior owner has reported any sinkhole, settlement or cracking damage regarding this property?
          </div>
          <div class="bolt-col-12 bolt-col-sm-3">
            <bolt-radio-group
              ngDefaultControl
              formControlName="doesApplicantKnowPriorOwnerReportedSinkholeDamage"
              [attr.horizontal]="horizontalRadio || null"
              id="shf-doesApplicantKnowPriorOwnerReportedSinkholeDamage"
              required
              [error]="errorMessage['doesApplicantKnowPriorOwnerReportedSinkholeDamage']"
              >
              <bolt-radio value="true">Yes</bolt-radio>
              <bolt-radio value="false">No</bolt-radio>
            </bolt-radio-group>
          </div>
        </div>
      </div>
    </div>
  </form>
}
